.navigation {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
}

.navigation ul {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.navigation button {
  position: relative;
  padding: 0.25rem;
  width: 40px;
  height: 40px;

  border-radius: 100%;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  background-color: black;
  border: 1px solid lightslategray;
  color: white;

  cursor: pointer;
}

.navigation hr {
  width: 100%;
  border: 1px solid lightslategray;
  opacity: 50%;
}

.checkmark {
  position: absolute;
  width: 22px;
  bottom: -9;
  right: -9;
}
